export const REGIONS_OVERVIEW_BLOCKS_PLACE_CONSTS = {
  selectPositionMsg: 'Выбрать позицию в картине дня'
}
